<template>
  <div class="form">
    <div class="sm:border-b sm:border-gray-400 sm:pb-5 mb-5">
      <h3 class="text-lg leading-6 font-semibold text-blue-600">Transfers</h3>
    </div>

    <div class="flex flex-col">
      <!-- <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"> -->
      <div class="py-2 align-middle inline-block min-w-full">
        <div class="overflow-hidden sm:rounded-lg">
          <data-table
            :items="transfers"
            :headers="headers"
            :selectable="false"
            :actions="[]"
          >
            <template v-slot:rows="slotRows">
              <transfer-row
                v-bind="slotRows"
                :selectable="false"
                :show-route="showPackageRoute"
              />
            </template>
          </data-table>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import DataTable from '@/Components/Table/DataTable'
import TransferRow from '@/Pages/Packages/Components/TransferRow'

export default {
  name: 'transfers-form',
  components: { DataTable, TransferRow },
  props: {
    transfers: {
      type: Array,
      default: []
    }
  },

  data() {
    return {
      headers: [
        'ID',
        'Sub-Lot',
        'Status',
        'From',
        'To',
        'Transfer Qty',
        'Transfer Date',
        'Initiated By',
        'Received At',
        'Received By'
      ]
    }
  },

  computed: {
    /**
     * Returns a function that when passed a package model, will return the correct url to view that package in
     * the browser.
     */
    showPackageRoute() {
      // A better argument name here would be 'package' but thats a reserved word in javascript
      return (item) => {
        return route('packages.show', { package: item.id })
      }
    }
  }
}
</script>
